import { useState, useEffect, useContext } from 'react';

import { getLocaleData } from './get-intl';
import { LocaleContext } from './locale-context-provider';
import { English, ShipStationSupportedLocales } from './locale-context-provider/locale-codes';

export const useLocale = () => {
  return useContext(LocaleContext);
};

export const useMessagesForLocale = (locale) => {
  const [messages, setMessages] = useState({});

  useEffect(() => {
    getLocaleData(locale).then((data) => setMessages(data.default));
  }, [locale]);

  return messages;
};

export const useIsLocaleAnEnglishVariant = () => {
  const { locale } = useLocale();
  const englishVariants = ShipStationSupportedLocales.filter((localeCode) => localeCode.startsWith(English));

  const isAnEnglishVariant = englishVariants.includes(locale);
  return isAnEnglishVariant;
};
